<kp-map-modal>
    <section class="column">
        <h3>{{ mutatable.properties.type }}</h3>
        <input #fileUpload style="display: none" type="file" accept="image/png,image/jpeg,image/gif,image/webp" (change)="addImg($event.target)" />
        <input #name placeholder="Name" [(ngModel)]="mutatable.properties.name" (blur)="mutate()" [disabled]="true" />
        <div class="row">
            <input
                #url
                placeholder="Background image…"
                (click)="fileUpload.click()"
                readonly
                value="{{ mutatable?.properties?.backgroundImageFileName || '' }}"
            />
            <button type="button" class="icon" aria-label="Remove background image" (click)="removeImage()">
                <img [src]="icons.del" alt="" />
            </button>
            <button #backgroundButton type="button" class="icon" aria-label="Edit background image" (click)="fileUpload.click()">
                <img [src]="icons.image" alt="" />
            </button>
        </div>
        <br />
        <div class="row flex-end">
            <!-- <button class="danger" (click)="requestRemove()" (keydown.enter)="requestRemove()">Remove from map</button> -->
            <button type="button" (click)="requestCancel()">Cancel</button>
            <button type="button" class="primary" (click)="requestOK()">OK</button>
        </div>
    </section>
</kp-map-modal>
